import { AlexaDevice } from '@/types/device';
import { api } from '../../api';

/**
 * This API endpoint is used to fetch a list of floating devices.
 * For more details on the system structure, refer to the API repo/docs folder
 */
const deviceImportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFloatingDevices: builder.query<AlexaDevice[], void>({
      query: () => ({
        url: '/device-import',
        method: 'GET',
      }),
      providesTags: ['UnimportedDevices'],
    }),
    importDevice: builder.mutation<void, { device: AlexaDevice }>({
      query: (body) => ({
        url: '/device-import',
        method: 'POST',
        body: { endpointId: body.device.endpointId },
      }),
      invalidatesTags: ['UnimportedDevices', 'Devices'],
    }),
  }),
});

export const { useGetFloatingDevicesQuery, useImportDeviceMutation } =
  deviceImportApi;
